@if (notificationStyle === NotificationStyle.Error) {
  <rt-icon name="error-outline" class="warning-icon" />
}

@if (notificationStyle === NotificationStyle.Success) {
  <div class="success">
    <rt-icon name="check" />
  </div>
}

@if (notificationStyle === NotificationStyle.InProgress) {
  <div class="progress">
    <rt-spinner variant="small-x" />
  </div>
}
